import moment from 'moment';
import numeral from 'numeral';


export function formatDateTime(date: Date | string | number) {
	return moment.utc(date).format('HH:mm:ss MM/DD/YYYY');
}

export function formatDate(date: Date | string | number) {
	return moment.utc(date).format('MM/DD/YYYY');
}

export function formatDateYear(date: string | number) {
	return moment.utc(date).format('YYYY');
}

export function formatNumber(number: string | number) {
	return numeral(number).format('0[.]0a');
}

export function formatPercent(number: string | number) {
	return numeral(number).format('0%');
}
